/* @flow */

import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'airbnb-js-shims';

import React from 'react';
import ReactDOM from 'react-dom';
import 'typeface-roboto';
import { MuiThemeProvider } from '@material-ui/core/styles';

import 'react-select/dist/react-select.css';
import 'react-virtualized/styles.css';
import 'react-virtualized-select/styles.css';
import 'react-placeholder/lib/reactPlaceholder.css';

import 'common-scss/global.scss';

import theme from 'common-scss/theme';
import initGTM from 'utils/gtm';

import RootComponent from 'Root';

export async function main(): Promise<*> {
  initGTM();

  const rootElement: ?HTMLElement = document.getElementById('root');

  if (rootElement) {
    ReactDOM.render(
      <MuiThemeProvider theme={theme}>
        <RootComponent />
      </MuiThemeProvider>,
      rootElement
    );
  }
}

main();
